<script>
  // Перенос Ico из src_ui/web/src/screens/menu/icons.tsx — дословно.
  // Значок набора. `s` — сторона квадрата в px (иконка всегда квадратная).
  // Неизвестное имя рисует «i в кружке» — чтобы пропущенный ключ был заметен.
  import { G, ALIAS } from './iconpaths.js';

  export let n = '';
  export let s = 18;
  let className = '';
  export { className as class };
  export let style = undefined;

  $: paths = G[n] ?? G[ALIAS[n]] ?? G.info;
</script>

<svg
  class={'mn-ico' + (className ? ' ' + className : '')}
  {style}
  width={s} height={s} viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="1.8"
  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
>
  {#each paths as d, i (i)}<path {d} />{/each}
</svg>
